module.exports = "/_next/static/images/684483fb4a9d4d167a7641d28c3e43c0-logos-hero.svg.webp";